import { test } from '../termExpressions';

async function getContent(countryCode: string) {
  switch (countryCode) {
    case 'US':
      return import('./content/us').then(m => m.default);

    default:
      return import('./content/gb').then(m => m.default);
  }
}

export default async function getHelpAndGuidanceResults(
  q: string,
  countryCode: string
) {
  const results = await getContent(countryCode);
  return results.filter(result => test(result.terms, q));
}
